import React from 'react';
import { NodeProps } from '@xyflow/react';
import ReviewSourceNode from './ReviewSourceNode';
import ReviewerCoreNode from './ReviewerCoreNode';
import ReviewPolicyNode, { ReviewVerdictNode } from './ReviewPolicyNode';

/**
 * The reviewer graph's node types, in one map so `PipelineCanvas` can merge
 * them with its own in a single spread. Both canvases then render the same
 * components — there is no second React Flow wrapper to keep in step, and the
 * reviewer picture can be embedded in the pipeline canvas later without any of
 * this moving.
 */
export const reviewerNodeTypes: Record<string, React.ComponentType<NodeProps>> = {
  'review-source': ReviewSourceNode,
  'reviewer-core': ReviewerCoreNode,
  'review-policy': ReviewPolicyNode,
  'review-verdict': ReviewVerdictNode,
};

export { ReviewSourceNode, ReviewerCoreNode, ReviewPolicyNode, ReviewVerdictNode };

export default reviewerNodeTypes;
